import React from 'react';

export function Input({ label, error, className = '', ...props }) {
  return (
    <div className="space-y-1">
      {label && <label className="block text-sm text-gray-400">{label}</label>}
      <input
        className={`w-full bg-gray-800 border ${error ? 'border-red-500' : 'border-gray-700'} text-white rounded-lg px-3 py-2.5 focus:outline-none focus:border-yellow-500 transition-colors placeholder-gray-600 text-sm ${className}`}
        {...props}
      />
      {error && <p className="text-red-400 text-xs">{error}</p>}
    </div>
  );
}

export function Select({ label, error, children, className = '', ...props }) {
  return (
    <div className="space-y-1">
      {label && <label className="block text-sm text-gray-400">{label}</label>}
      <select
        className={`w-full bg-gray-800 border ${error ? 'border-red-500' : 'border-gray-700'} text-white rounded-lg px-3 py-2.5 focus:outline-none focus:border-yellow-500 transition-colors text-sm ${className}`}
        {...props}
      >
        {children}
      </select>
      {error && <p className="text-red-400 text-xs">{error}</p>}
    </div>
  );
}

export function Textarea({ label, error, className = '', ...props }) {
  return (
    <div className="space-y-1">
      {label && <label className="block text-sm text-gray-400">{label}</label>}
      <textarea
        className={`w-full bg-gray-800 border ${error ? 'border-red-500' : 'border-gray-700'} text-white rounded-lg px-3 py-2.5 focus:outline-none focus:border-yellow-500 transition-colors placeholder-gray-600 text-sm resize-none ${className}`}
        rows={3}
        {...props}
      />
      {error && <p className="text-red-400 text-xs">{error}</p>}
    </div>
  );
}

export function Button({ children, variant = 'primary', loading, className = '', ...props }) {
  const variants = {
    primary: 'bg-yellow-600 hover:bg-yellow-500 text-black font-semibold',
    secondary: 'bg-gray-700 hover:bg-gray-600 text-white',
    danger: 'bg-red-700 hover:bg-red-600 text-white',
    ghost: 'text-gray-400 hover:text-white hover:bg-gray-800',
  };
  return (
    <button
      className={`inline-flex items-center justify-center space-x-2 px-4 py-2.5 rounded-lg transition-all text-sm disabled:opacity-60 disabled:cursor-not-allowed ${variants[variant]} ${className}`}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />}
      <span>{children}</span>
    </button>
  );
}
